module.exports = __webpack_public_path__ + "static/media/with-image.31e8e469.svg";